import commonApi from './CommonApi.js';

export default {
	import: async (viewModel) => {
		return await commonApi().post('/v1/tprs/import?language=' + window.currentLanguageEnum, viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	get: async (parameter) => {
		return await commonApi().get('/v1/tprs/get', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
}